<div class="loading" *ngIf="loading == true">Loading&#8230;</div>
<div class="main-container forms-and-documents" id="forms-and-documents">
    <mat-card class="table-card">
        <div class="card-header-section">
            <div class="left-content ">
                <h4 class="heading-4">Forms Completed</h4>
            </div>
            <div class="right-content">
                <button (click)="getUrbanPlannerRegisterReport()"
                    class="add-button-margin center-content add-button display-right mt-10 hidden">
                    <mat-icon class="add-icon">add</mat-icon>
                    <span class="paragraph buttonColor">Urban planner register report</span>
                </button>
            </div>
        </div>
        <div class="documents-table-container">
            <div class="row">
                <div class="col-12">
                    <mat-table [dataSource]="dataSourceUrbanPlannerRegisterReport" matSort
                        *ngIf="dataSourceUrbanPlannerRegisterReport.data.length > 0">
                        <mat-header-row *matHeaderRowDef="dataCompletedString"></mat-header-row>
                        <mat-row class="paragraph"
                            *matRowDef="let row; let i = index; columns: dataCompletedString;"></mat-row>
                        <ng-container matColumnDef="number">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="documentNumber">
                                Document ID
                            </mat-header-cell>
                            <mat-cell *matCellDef="let urbanPlannerRegister; let i = index" class="bold">
                                #{{ i + 1 }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="completedforms">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="exportedFileName">
                                Document Name
                            </mat-header-cell>
                            <mat-cell *matCellDef="let urbanPlannerRegister; let i = index">
                                Planner Registration
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="date">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="createdDate">
                                Export Date
                            </mat-header-cell>
                            <mat-cell *matCellDef="let urbanPlannerRegister; let i = index">
                                {{ formatDate(urbanPlannerRegister?.createdDate) }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="download">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="downloadUrl">
                                Download
                            </mat-header-cell>
                            <mat-cell *matCellDef="let urbanPlannerRegister; let i = index">
                                <a [href]="urbanPlannerRegister?.downloadUrl" target="_blank" download>
                                    <mat-icon class="material-icons-outlined download-icon">download</mat-icon>
                                </a>
                            </mat-cell>
                        </ng-container>
                    </mat-table>
                </div>
                <div class="col-12">
                    <mat-table [dataSource]="dataSourceEstateAgentRegisterReport" matSort
                        *ngIf="dataSourceEstateAgentRegisterReport.data.length > 0">
                        <mat-header-row *matHeaderRowDef="dataCompletedString"></mat-header-row>
                        <mat-row class="paragraph"
                            *matRowDef="let row; let i = index; columns: dataCompletedString;"></mat-row>
                        <ng-container matColumnDef="number">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="documentNumber">
                                Document ID
                            </mat-header-cell>
                            <mat-cell *matCellDef="let agentRegister; let i = index" class="bold">
                                #{{ i + 1 }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="completedforms">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="exportedFileName">
                                Document Name
                            </mat-header-cell>
                            <mat-cell *matCellDef="let agentRegister; let i = index">
                                Agent Registration
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="date">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="createdDate">
                                Export Date
                            </mat-header-cell>
                            <mat-cell *matCellDef="let agentRegister; let i = index">
                                {{ formatDate(agentRegister?.createdDate) }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="download">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="downloadUrl">
                                Download
                            </mat-header-cell>
                            <mat-cell *matCellDef="let agentRegister; let i = index">
                                <a [href]="agentRegister?.downloadUrl" target="_blank" download>
                                    <mat-icon class="material-icons-outlined download-icon">download</mat-icon>
                                </a>
                            </mat-cell>
                        </ng-container>
                    </mat-table>
                </div>
            </div>
        </div>
    </mat-card>
    <br>
    <mat-card class="table-card">
        <div class="card-header-section">
            <div class="left-content">
                <h4 class="heading-4">Documents Uploaded</h4>
            </div>
            <div class="right-content mt-10">
                <button (click)="addDocumentsDialog()"
                    class="add-button-margin center-content add-button display-right mt-10 hidden">
                    <mat-icon class="add-icon">add</mat-icon>
                    <span class="paragraph buttonColor">Add documents</span>
                </button>
            </div>
        </div>
        <div class="documents-table-container">
            <mat-table [dataSource]="dataSourceUrbanPlannerDocuments" matSort>
                <mat-header-row *matHeaderRowDef="dataDocumentsString"></mat-header-row>
                <mat-row class="paragraph" *matRowDef="let row; let i = index; columns: dataDocumentsString;"></mat-row>
                <ng-container matColumnDef="number">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="documentNumber">
                        Document ID
                    </mat-header-cell>
                    <mat-cell *matCellDef="let plannerDocuments; let i = index" class="bold">
                        #{{ i + 1 }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="documentInfo.name">
                        Document Name
                    </mat-header-cell>
                    <mat-cell *matCellDef="let plannerDocuments; let i = index">
                        {{ plannerDocuments?.documentInfo?.name }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="uploadBy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="documentInfo.updatedBy">
                        Document Name
                    </mat-header-cell>
                    <mat-cell *matCellDef="let plannerDocuments; let i = index">
                        {{ plannerDocuments?.documentInfo?.updatedBy }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="uploadDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="createdDate">
                        Export Date
                    </mat-header-cell>
                    <mat-cell *matCellDef="let plannerDocuments; let i = index">
                        {{ formatDate(plannerDocuments?.documentInfo?.createdDate) }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="download">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="downloadUrl">
                        Download
                    </mat-header-cell>
                    <mat-cell *matCellDef="let plannerDocuments; let i = index">
                        <a [href]="plannerDocuments?.documentInfo?.fileDownloadURL" target="_blank" download>
                            <mat-icon class="material-icons-outlined download-icon">download</mat-icon>
                        </a>
                    </mat-cell>
                </ng-container>
            </mat-table>
        </div>
    </mat-card>
</div>